export default "__VITE_ASSET__D66Jt5IU__"